import { createAsyncThunk } from '@reduxjs/toolkit';
import { graphqlRequest, hasGraphQLNetworkError } from '~/adapters/graphqlRequest';
import {
  GetLifecycleSurveyTriggerTypesDocument,
  GetLifecycleSurveyTriggerTypesQueryResult,
  InputLifecycleSurveyTriggerType,
  UpsertLifecycleSurveyTriggerTypesDocument,
  UpsertLifecycleSurveyTriggerTypesMutationResult,
} from '~/gql/graphql';

const getLifecycleSurveyTriggerTypes = createAsyncThunk(
  'mailingLists/getLifecycleSurveyTriggerTypes',
  async (_, { rejectWithValue }) => {
    const res = await graphqlRequest<GetLifecycleSurveyTriggerTypesQueryResult>(GetLifecycleSurveyTriggerTypesDocument);

    if (hasGraphQLNetworkError(res)) return rejectWithValue(res.error);

    return res.data?.getLifecycleSurveyTriggerTypes;
  },
);

const upsertLifecycleSurveyTriggerTypes = createAsyncThunk(
  'mailingLists/upsertLifecycleSurveyTriggerTypes',
  async (input: InputLifecycleSurveyTriggerType[], { rejectWithValue }) => {
    const res = await graphqlRequest<UpsertLifecycleSurveyTriggerTypesMutationResult>(
      UpsertLifecycleSurveyTriggerTypesDocument,
      {
        lifecycleSurveyTriggerTypes: input,
      },
    );

    if (hasGraphQLNetworkError(res)) return rejectWithValue(res.error);

    return res.data?.upsertLifecycleSurveyTriggerTypes;
  },
);

// This is related to the lifecycleSurveyTriggerTypeToCompany table
export const lifecycleSurveyTriggerTypesActions = {
  getLifecycleSurveyTriggerTypes,
  upsertLifecycleSurveyTriggerTypes,
};
